/* The class-vs-class equity table. 43 KB of text that only the viewer's tooltip reads, so it
   is its own chunk, fetched once and decoded once. */

import { decodeEquity, type EquityTable } from "@preflop/core";

let loading: Promise<EquityTable | null> | null = null;

export function loadEquity(): Promise<EquityTable | null> {
  loading ??= import("../../../../data/equity/equity.txt?raw")
    .then((m) => decodeEquity(m.default))
    .catch(() => null);
  return loading;
}
